// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__386gj","title":"Images45_title__1X04p","images":"Images45_images__jpEyk"};